import React, { useState } from "react";
import "./contact.css";
import { ContactUs } from "api-services";
import { useDispatch } from "react-redux";

function Contact() {
  const dispatch = useDispatch();
  const [fullname, setFullname] = useState("");
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");

  //   Form validation
  const [errors, setErrors] = useState({});

  //   Setting button text
  const [buttonText, setButtonText] = useState("Submit");

  const [showSuccessMessage, setShowSuccessMessage] = useState(false);
  const [showFailureMessage, setShowFailureMessage] = useState(false);

  const handleValidation = () => {
    let tempErrors = {};
    let isValid = true;

    if (fullname.length <= 0) {
      tempErrors["fullname"] = true;
      isValid = false;
    }
    const regexName = /^[a-zA-Z\s]+$/;
    if (fullname.length > 0 && !regexName.test(fullname)) {
      tempErrors["regexName"] = "Please enter valid name";
      isValid = false;
    }
    if (email.length <= 0) {
      tempErrors["email"] = true;
      isValid = false;
    }
    if (message.length <= 0) {
      tempErrors["message"] = true;
      isValid = false;
    }

    setErrors({ ...tempErrors });
    return isValid;
  };

  const clearFields = () => {
    setButtonText("Send");

    setFullname("");
    setEmail("");
    setMessage("");
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    let isValidForm = handleValidation();

    if (isValidForm) {
      setButtonText("Sending");
      ContactUs(
        dispatch,
        {
          body:
            "Full Name: " +
            fullname +
            "\n Email Address: " +
            email +
            "\n Message: " +
            message,
        },
        () => {
          setShowSuccessMessage(true);
          setShowFailureMessage(false);
          setButtonText("Send");
          // Reset form fields
          setFullname("");
          setEmail("");
          setMessage("");
        },
        (err) => {
          console.log(err);
          setShowSuccessMessage(false);
          setShowFailureMessage(true);
          setButtonText("Send");

          // Reset form fields
          setFullname("");
          setEmail("");
          setMessage("");
        },
        clearFields
      );
    }
  };

  let errorMessage = "";

  if (errors?.fullname) {
    errorMessage = "Full Name cannot be empty.";
  } else if (errors.regexName) {
    errorMessage = errors.regexName;
  }

  return (
    <>
      <div className="wrap-contact" id="contact-sec">
        <div className="container">
          <div className="row mx-0 ">
            <div className="contact-inner-wrap">
              <form className="row p-md-5" onSubmit={handleSubmit}>
                <h3 className="contact-title">Contact Us</h3>
                <p className="contact-desc">
                  Have further questions? Reach out to our support team using
                  the form below.
                </p>
                <div className="col-md-6 mb-3">
                  <input
                    type="text"
                    className="form-control"
                    id="fullname"
                    name="fullname"
                    placeholder="Full Name*"
                    value={fullname}
                    onChange={(e) => {
                      setFullname(e.target.value);
                    }}
                  />
                  {
                    // errors?.fullname ? (
                    //   <p className="text-red">Full Name cannot be empty.</p>
                    // ) : errors.regexName ? (
                    //   <p className="text-red">{errors.regexName}</p>
                    // ) : (
                    //   ""
                    // )
                    errorMessage && <p className="text-red">{errorMessage}</p>
                  }
                </div>
                <div className="col-md-6 mb-3">
                  <input
                    type="email"
                    className="form-control"
                    id="email"
                    placeholder="Email Address*"
                    value={email}
                    onChange={(e) => {
                      setEmail(e.target.value);
                    }}
                  />
                  {errors?.email && (
                    <p className="text-red">Email Address cannot be empty.</p>
                  )}
                </div>
                <div className="col-md-12 mb-3">
                  <textarea
                    className="form-control"
                    rows={10}
                    maxLength={1000}
                    id="message"
                    placeholder="Your Message*"
                    value={message}
                    onChange={(e) => {
                      setMessage(e.target.value);
                    }}
                  />
                  {errors?.message && (
                    <p className="text-red">Your Message cannot be empty.</p>
                  )}
                </div>
                <div className="d-grid gap-2 col-5 col-md-3 mx-auto mb-3">
                  <button className="btn btn-contact"> {buttonText} </button>
                </div>
                <div className="row">
                  <div className="container">
                    <div className="d-grid gap-2 col-12 col-md-6 mx-auto mb-3 text-center res">
                      {showSuccessMessage && (
                        <p className="text-green-500 font-semibold text-sm my-2">
                          Thank you! Your message has been delivered.
                        </p>
                      )}
                      {showFailureMessage && (
                        <p className="text-red text-center">
                          Oops! Something went wrong, please try again.
                        </p>
                      )}
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      <div className="modal-dialog modal-dialog-scrollable">
        <div
          className="modal fade"
          id="staticBackdrop"
          data-bs-backdrop="static"
          data-bs-keyboard="false"
          tabIndex="-1"
          aria-labelledby="staticBackdropLabel"
          aria-hidden="true"
        >
          <div className="modal-dialog modal-dialog-scrollable modal-lg">
            <div className="modal-content">
              <div className="modal-body">
                <button
                  type="button"
                  className="btn-close float-end"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                ></button>
                {/* <img src={NdaOne} className="mx-auto d-block" />
                                <img src={NdaTwo} className="mx-auto d-block" /> */}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Contact;
